import type { RbacSnapshot } from './types';

const KEY = 'agd.rbac.snapshot';

export function loadRbacSnapshot(): RbacSnapshot | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as RbacSnapshot;
    if (!parsed || typeof parsed !== 'object') return null;
    if (typeof parsed.roleId !== 'number') return null;
    if (!Array.isArray(parsed.permissions)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveRbacSnapshot(snapshot: RbacSnapshot): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    // ignore
  }
}

export function clearRbacSnapshot(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

